import { Table } from "@/components";
import type { Measurement } from "@/components/Table/Table";
import type { PerformanceTabData } from "@/hooks/usePerformanceSectionData";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { useState } from "react";
import * as summaryStyles from "./SummaryTab.css";
import * as styles from "./Tables.css";

type Props = {
	data: PerformanceTabData["summary"];
	styleVariants?: summaryStyles.WrapVariants;
};
export default function SummaryTab({ data, styleVariants }: Props) {
	const [cumulativeTitleLeft, setCumulativeLeft] = useState(0);
	const [cumulativeTitleRight, setCumulativeRight] = useState(0);
	const handleColumnMeasurements = (m: Measurement[]) => {
		const left = Math.min(...m.map((_m) => _m.left));
		const right = Math.min(...m.map((_m) => _m.right));
		setCumulativeLeft(left);
		setCumulativeRight(right);
	};
	return (
		<div className={`${styles.wrap()} ${summaryStyles.wrap(styleVariants)}`}>
			<div>
				<div className={styles.superTitleWrap}>
					<h4
						className={styles.superTitle({ absolute: true })}
						style={assignInlineVars({
							[styles.superTitleLeft]: `${cumulativeTitleLeft}px`,
							[styles.superTitleRight]: `${cumulativeTitleRight}px`,
						})}
					>
						{data.cumulative.header ?? "Cumulative"}
					</h4>
				</div>
				<Table
					data={data.cumulative.data}
					headers={data.cumulative.headers}
					className={styles.table}
					highlightColumns={["3 years", "Launch"]}
					onColumnMeasurements={handleColumnMeasurements}
				/>
			</div>
			<div className={summaryStyles.annualisedWrap}>
				{data.annualised.header && (
					<h4 className={styles.superTitle()}>{data.annualised.header}</h4>
				)}
				<Table
					data={data.annualised.data}
					headers={data.annualised.headers}
					className={styles.tableAnn}
				/>
			</div>
		</div>
	);
}
